import { faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import PropTypes from "prop-types";

const ExpandableModal = ({ title, content, contractNo }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
        aria-label="View details"
      >
        <FontAwesomeIcon icon={faFile} />
      </button>

      {isOpen && (
        <div className="modal-backdrop" onClick={() => setIsOpen(false)}>
          <div className="expandable-modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className="modal-header sticky-top bg-white"
              style={{ zIndex: 1 }}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <div style={{ textAlign: "left" }}>
                  <h5>{title}</h5>
                  {contractNo && (
                    <span className="text-muted" style={{ fontWeight: 600 }}>
                      Contract No: {contractNo}
                    </span>
                  )}
                </div>

                <button
                  className="close-btn"
                  onClick={() => setIsOpen(false)}
                  aria-label="Close modal"
                >
                  &times;
                </button>
              </div>
            </div>
            <div
              className="modal-body"
              style={{
                overflow: "auto",
                maxHeight: "60vh",
                maxWidth: "90vw",
                whiteSpace: "pre-wrap",
              }}
            >
              {content}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

ExpandableModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  contractNo: PropTypes.string,
};

ExpandableModal.defaultProps = {
  contractNo: null,
};

export default React.memo(ExpandableModal);
